import ObjectIdentifier from "sap/m/ObjectIdentifier";
import Text from "sap/m/Text";
import { MetadataOptions } from "sap/ui/core/Element";
import ObjectIdentifierWithSubtitleRenderer from "./ObjectIdentifierWithSubtitleRenderer";
import ManagedObject from "sap/ui/base/ManagedObject";
import Control from "sap/ui/core/Control";

/**
 * @name com.unitrade.crm.controls.objectIdentifierWithSubtitle.ObjectIdentifierWithSubtitle
 */
export default class ObjectIdentifierWithSubtitle extends ObjectIdentifier {
	_hasTopRow: any;
    _getTitleControl: any;
    _getTextControl: any;

    // The following three lines were generated and should remain as-is to make TypeScript aware of the constructor signatures
    constructor(idOrSettings?: string | $ObjectIdentifierWithSubtitleSettings);
    constructor(id?: string, settings?: $ObjectIdentifierWithSubtitleSettings);
    constructor(id?: string, settings?: $ObjectIdentifierWithSubtitleSettings) { super(id, settings); }

    static readonly metadata: MetadataOptions = {
        properties: {
            /**
             * Defines the subtitle
             */
            subtitle: {
                type: "string",
                group: "Data",
                defaultValue: null
            }
        },
        aggregations: {
            _subtitleControl: {type: "sap.ui.core.Control", multiple: false, visibility: "hidden"}
        }
      };

      _getSubtitleControl = (): Control => {
        let oSubtitleControl = this.getAggregation("_subtitleControl") as Control;

        if (!oSubtitleControl) {
            oSubtitleControl = new Text({
               text: ManagedObject.escapeSettingsValue(this.getProperty("subtitle")),
               textDirection: this.getTextDirection()
            });

            this.setAggregation("_subtitleControl", oSubtitleControl, true);

            return oSubtitleControl;
        }
      }

      static renderer = ObjectIdentifierWithSubtitleRenderer;
}